import TOS from '!!raw-loader!../assets/tos-current.html'; // eslint-disable-line
import { styled } from 'css-literal-loader/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from './Button';
import Card from './Card';
import FadeScroller from './FadeScroller';
import Modal from './Modal';

const TermsButton = styled(Button, null, "TermsButton", require("./TermsAndConditionsModal-TermsButton.module.scss"), "terms-button", "termsButton");

const ScrollBody = styled(Modal.Body, null, "ScrollBody", require("./TermsAndConditionsModal-ScrollBody.module.scss"), "scroll-body", "scrollBody");
const propTypes = {};

class TermsAndConditionsModal extends React.Component {
  handleAccept = () => {
    const { onAccept, onHide } = this.props;
    onAccept(true);
    onHide();
  };

  render() {
    return (
      <Modal {...this.props} closeButton fullHeight>
        <ScrollBody>
          <FadeScroller>
            <div dangerouslySetInnerHTML={{ __html: TOS }} />
          </FadeScroller>
        </ScrollBody>
        <Card.Footer noBorder>
          <TermsButton onClick={this.handleAccept}>
            <FormattedMessage
              defaultMessage="Accept Terms and Conditions"
              id="termsAndConditions.accept"
            />
          </TermsButton>
        </Card.Footer>
      </Modal>
    );
  }
}

TermsAndConditionsModal.propTypes = propTypes;

export default TermsAndConditionsModal;
